export default __webpack_public_path__ + "3050c64ed23aa4265c094ad478b10224.svg";